import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class ProfileService {

    async updateProfile(id, data) {
        const response = await ajaxService.post(`/auth/user/`, data, id);
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async fetchPermissions() {
        const response = await ajaxService.get(`/columns_view`);
        if (response ?? false) {
            return response;
        }
    }
    async fetchLoggedUser() {
        const response = await ajaxService.get(`/auth/user`);
        if (response ?? false) {
            return response;
        }
    }

    async fetchRolePermissions() {
        const response = await ajaxService.get(`/auth/user/roles-permissions`);
        // if (response?.success ?? false) {
        return response
        // }
    }
}

const profileService = new ProfileService();
export default profileService;